/**
 * The language codes the engine is able to render, derived at build time from
 * the translation files in assets/lang. Dropping another language file into
 * that folder is all that is required to support a new survey language --
 * the survey schema and the translation loader both read from this list, so
 * they can never drift apart.
 *
 * The context is created in 'lazy' mode so we only pull in the file names; the
 * translations themselves stay in their own chunks and are fetched on demand.
 */
const translationFiles = require.context('../assets/lang', false, /\.json$/, 'lazy');
export const supportedLanguages = translationFiles
    .keys()
    .map(path => path.replace(/^\.\//, '').replace(/\.json$/, '').toLowerCase())
    .sort();
